// removed by extract-text-webpack-plugin
module.exports = {"root":"js-components-CourseList-CourseRenderer-module__root--3lPnQ","body":"js-components-CourseList-CourseRenderer-module__body--23KRv"};